import { render, staticRenderFns } from "./IPAddressesList.vue?vue&type=template&id=0d85b826&scoped=true"
import script from "./IPAddressesList.vue?vue&type=script&lang=js"
export * from "./IPAddressesList.vue?vue&type=script&lang=js"
import style0 from "./IPAddressesList.vue?vue&type=style&index=0&id=0d85b826&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85b826",
  null
  
)

export default component.exports